import type { MailboxInfo } from 'owa-client-types';
import { getGroupInformation } from './getGroupInformation';

export default function isDeletedGroup(mailboxInfo: MailboxInfo, groupId: string): boolean {
    return !!getGroupInformation(mailboxInfo, groupId)?.basicInformation?.WhenSoftDeletedUtc;
}
